export class SalesChannelModel {
    public salesChanl: string;
    public commPlanIds : any;
    constructor(){
            this.salesChanl = null;
            this.commPlanIds = [];
        }
}
